import { diseases } from './diseases';

const DAY_MS = 24 * 60 * 60 * 1000;

// Today's date in UTC (YYYY-MM-DD). The puzzle rolls over at UTC midnight
// so every player worldwide gets the same disease on the same day.
export const getTodayString = (now = new Date()) => now.toISOString().split('T')[0];

// Day of year (1-366) computed purely in UTC, so the result doesn't depend
// on the player's time zone.
export const getDayOfYear = (dateString) => {
  const [year, month, day] = dateString.split('-').map(Number);
  return Math.round((Date.UTC(year, month - 1, day) - Date.UTC(year, 0, 1)) / DAY_MS) + 1;
};

export const getDailyDisease = (dateString) =>
  diseases[(getDayOfYear(dateString) - 1) % diseases.length];

export const addDays = (dateString, days) => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day) + days * DAY_MS).toISOString().split('T')[0];
};

export const getMsUntilNextPuzzle = (now = new Date()) => {
  const nextMidnight = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1);
  return nextMidnight - now.getTime();
};

export const formatCountdown = (ms) => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(Math.floor(totalSeconds / 3600))}:${pad(Math.floor((totalSeconds % 3600) / 60))}:${pad(totalSeconds % 60)}`;
};

export const EMPTY_STATS = { played: 0, currentStreak: 0, lastWonDate: null };

// A streak is still alive if the last win was today or yesterday.
export const getActiveStreak = (stats, today) =>
  stats.lastWonDate === today || stats.lastWonDate === addDays(today, -1) ? stats.currentStreak : 0;

export const recordWin = (stats, today) => {
  if (stats.lastWonDate === today) return stats;
  const currentStreak = stats.lastWonDate === addDays(today, -1) ? stats.currentStreak + 1 : 1;
  return { played: stats.played + 1, currentStreak, lastWonDate: today };
};
